<template>
    <div class="welcome-body">
        <div class="container">
            <img src="../../assets/img/Notica-logo.png" alt="Notica Logo">
            <h1>نوتیکا</h1>
            <p>سامانه ارسال پیام در بستر اینترنت</p>
        </div>
        <div>
            <button @click="nextPage" class="welcome-btn">ورود</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage: 0,
        }
    },
    methods: {
        nextPage (){
            this.$emit('nextPage', 'phone')
        }
    }
}
</script>

<style scoped>
    .welcome-body {
        background-color: #25292E;
        height: 100vh;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 75px;
    }
    img {
        width: 215px;
        height: 200px;
    }
    h1 {
        font-size: 38px;
        color: #028D92;
    }
    p {
        font-size: 18px;
        color: #028D92;
    }
    .welcome-btn {
        background-color: #028D92;
        color: white;
        border: none;
        border-radius: 20px;
        font-size: 22px;
        cursor: pointer;
        width: 175px;
        height: 40px;
    }

</style>